var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "16 16 18 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M21.689 19.027l-.681-1.374A8.953 8.953 0 0 0 16 25.718c0 4.956 4.033 8.989 8.988 8.989 4.956 0 8.989-4.033 8.989-8.989a8.956 8.956 0 0 0-5.008-8.065l-.682 1.374a7.427 7.427 0 0 1 4.156 6.69c0 4.11-3.345 7.455-7.455 7.455-4.11 0-7.455-3.346-7.455-7.455a7.425 7.425 0 0 1 4.156-6.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M24.222 16h1.533v9.717h-1.533z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.22cde896884e4f0e3e33feb7b84cdab6.svg";
export { ForwardRef as ReactComponent };